/** Translate an incoming app link into a HashRouter route. */
export function getDeepLinkTarget(url: string): string | null {
  try {
    const parsed = new URL(url);
    const resetToken = parsed.searchParams.get("resetToken");
    if (resetToken) {
      return `/login/password-reset?resetToken=${encodeURIComponent(
        resetToken
      )}`;
    }
    const target = parsed.hash
      ? parsed.hash.replace(/^#/, "")
      : parsed.pathname;
    return target && target !== "/" ? target : null;
  } catch {
    return null;
  }
}
